function state() {
  return {
    customers: [],
    customersMeta: {},
    customer: {},
    customerMeta: {},
    statuses: [],
  };
}

export default state;
